import Purchase from '@/pages/Purchase'

// export default {
//   path: '/purchase',
//   name: 'purchase',
//   component: Purchase
// }

export default {
  path: '/purchase',
  component: Purchase,
  children: [
    {
      path: '/purchase',
      name: 'purchase',
      component: Purchase
    },
    {
      path: '/purchase/ref/:refcode',
      name: 'ReferralCode',
      component: Purchase,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/purchase.js